import { motion } from "framer-motion";

const Reveal = ({ children, delay = 0, y = 36, className = "", id }) => (
  <motion.div
    id={id}
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.25, 1, 0.5, 1] }}
  >
    {children}
  </motion.div>
);

export default Reveal;
